import { IFootballLiveScore } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { LiveScoreSubscription } from "../types";
import { isValidLiveScoreSubscription } from "./typeguards";
// import { CreateLiveScoreInputSchema } from 'appsync';

export default (obj: LiveScoreSubscription): IFootballLiveScore => {
  if (isValidLiveScoreSubscription(obj)) {
    // CreateLiveScoreInputSchema().parse(obj.data.onUpdateLiveScoreById, {reportInput: true});
    
    const { currentDay } = obj.data.onUpdateLiveScoreById;

    return {
      currentDay: (currentDay ?? []) as IFootballLiveScore["currentDay"],
    } as IFootballLiveScore;
  }

  throw new WidgetError<ErrorName>({
    name: "NO_VALID_DATA",
    message: "Invalid transformer input, Error in LiveScoreSubscription object",
    data: obj,
  });
};
